var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-container',{staticClass:"main-content-container px-4",attrs:{"fluid":""}},[_c('page-header',{attrs:{"title":"Indicação","subTitle":"Visualizar"}}),_c('d-row',[_c('d-col',{attrs:{"lg":"12"}},[_c('lead-page',{ref:"leadForm",attrs:{"lead":_vm.lead}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }